<template>
    <li :class="{ 'is-active': isActive }">
        <div class="accordion-header text-sm" @click="isActive ? closeItem() : openItem()">
            <span class="h6 m-0">
                <span v-if="title.status" class="track-status">{{ title.status }}</span>
                {{ title.parcelNo || title.no }}
                <span v-if="title.trackingNo && title.trackingNo !== title.parcelNo" class="track-alt-no">{{ title.trackingNo }}</span>
                <span v-if="title.brandType" class="track-brand">{{ title.brandType }}</span>
                <span v-if="title.city" class="track-city">&rarr; {{ title.city }}</span>
            </span>
            <div class="accordion-icon"></div>
        </div>
        <div ref="content" class="accordion-content text-xs">
            <p>
                <slot />
            </p>
        </div>
    </li>
</template>

<script>
export default {
  name: 'CAccordionItem',
  props: {
    active: Boolean,
    title: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isActive: this.active || false
    }
  },
  methods: {
    openItem() {
      this.$refs.content.style.maxHeight =
        this.$refs.content.scrollHeight + 'px'
      this.isActive = true
    },
    closeItem() {
      this.$refs.content.style.maxHeight = null
      this.isActive = false
    }
  },
  mounted() {
    this.isActive && this.openItem()
  }
}
</script>

<style scoped>
.track-status {
    display: inline-block;
    background: #E3EDFB;
    color: #14479A;
    border-radius: 999px;
    padding: 2px 10px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
    margin-right: 8px;
    vertical-align: middle;
}
.track-alt-no {
    margin-left: 5px;
}
.track-brand {
    margin-left: 10px;
}
.track-city {
    margin-left: 10px;
}
</style>
